import {
  BANK_ACCOUNT,
  CREDIT_CARD,
  PAYMENT_METHOD_IDS,
  STRIPE_PAYMENT_TYPE,
} from '../constants';
import { stripeGetApi } from './stripeApi';
import { doNothing } from './utils';

export const decodeStripeToken = async (token) => {
  const paymentType = {};

  try {
    const url = `payment-methods?paymentMethodId=${token}`;
    const response = await stripeGetApi(url);

    paymentType.paymentTypeId =
      response?.data.paymentType === STRIPE_PAYMENT_TYPE.creditCard
        ? PAYMENT_METHOD_IDS.creditCard
        : PAYMENT_METHOD_IDS.ach;
    paymentType.paymentName =
      response?.data.paymentType === STRIPE_PAYMENT_TYPE.creditCard
        ? CREDIT_CARD
        : BANK_ACCOUNT;
  } catch (_) {
    doNothing();
  }

  return paymentType;
};
